import React from 'react';
import CMPImage from 'components/global/image';

interface IProps {
  size?: 'small' | 'medium' | 'large';
  purple?: boolean;
}

const Logo: React.FunctionComponent<IProps> = ({ size = 'medium', purple }) => {
  const s = size === 'small' ? 20 : 'medium' ? 50 : 50;
  return (
    <CMPImage
      asset={{
        src: `${process.env.PUBLIC_URL}/images/${purple ? 'logo.svg' : 'logo-whiter.png'}`,
        alt: 'Cosmic Market Place',
      }}
      width={s}
      height={s}
    />
  );
};
export default Logo;
